/**
 * MSAL Configuration voor Entra ID authenticatie
 */

import { Configuration, PopupRequest } from '@azure/msal-browser';

/**
 * MSAL configuratie object
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Gebruik sessionStorage voor betere privacy
    storeAuthStateInCookie: true, // Vereist voor mobiele browsers die third-party cookies blokkeren (iOS Safari, etc.)
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0: // Error
            console.error(message);
            break;
          case 1: // Warning
            console.warn(message);
            break;
          case 2: // Info
            console.info(message);
            break;
          case 3: // Verbose
            console.debug(message);
            break;
        }
      },
    },
  },
};

/**
 * Scopes voor login request (Microsoft Graph)
 */
export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'Sites.ReadWrite.All'],
  prompt: 'select_account',
};

/**
 * Scopes voor API access
 */
export const apiScopes = {
  api: [`api://${import.meta.env.VITE_ENTRA_CLIENT_ID}/access_as_user`],
};

/**
 * Valideer of de configuratie compleet is
 */
export const validateConfig = (): boolean => {
  const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
  const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;

  if (!clientId || !tenantId) {
    console.error('MSAL configuratie incompleet. Zorg dat VITE_ENTRA_CLIENT_ID en VITE_ENTRA_TENANT_ID zijn ingesteld.');
    return false;
  }

  return true;
};
